import type { Drawing, LotteryNumberString } from '../../../../lottery-results/types';
import { mapLotteryResults } from '../../../mappers/lotteryNumberMappers';
import type { ExtraGameName, LotteryName, ParticipationState, WinningInfo } from '../../../types';
import { shouldShowWinnings } from '../../../utils/hasWinnings/hasWinnings';

type LineInfo = {
  numbers: number[];
  extraNumbers: number[];
  lineNumber: number;
};

function isMatchingLotteryNumber(lineNumber: number, resultNumber: LotteryNumberString): boolean {
  return lineNumber === Number(resultNumber);
}

function getMatchingLineNumbers(lineNumbers: number[], resultNumbers: LotteryNumberString[]): number[] {
  return lineNumbers.filter(number => resultNumbers.some(resultNumber => isMatchingLotteryNumber(number, resultNumber)));
}

/**
 * A function that calculates the matching numbers for a line.
 * A line is highlighted when it has winningPerLine, or when realWinning is
 * present and the line has a winning tier.
 */
function getLineMatching(
  lotteryName: LotteryName,
  gameName: LotteryName | ExtraGameName,
  results: Drawing,
  lineInfo: LineInfo,
  winningInfo: WinningInfo[],
  participationState?: ParticipationState,
  realWinning?: number
) {
  const winningLines = winningInfo.filter(info => info.lineNumber === lineInfo.lineNumber);
  const isHighlighted = shouldShowWinnings(participationState, winningLines, realWinning);
  const mappedResults = mapLotteryResults(lotteryName, gameName, results);

  return {
    numbers: getMatchingLineNumbers(lineInfo.numbers, mappedResults.numbers),
    extraNumbers: getMatchingLineNumbers(lineInfo.extraNumbers, mappedResults.extraNumbers ?? []),
    isHighlighted,
  };
}

export { getLineMatching };
